export default __webpack_public_path__ + "static/media/not-found-img.abed3b25.svg";